import Root from "../views/Root.vue";

import Dashboard from "../views/backoffice/Dashboard.vue";
import UserList from "../views/backoffice/user/UserList.vue";
import UserDetailRoot from "../views/backoffice/user/UserDetailRoot.vue";
import UserDetailOverview from "../views/backoffice/user/details/Overview.vue";
import UserDetailProducts from "../views/backoffice/user/details/Products.vue";
import UserDetailAppointments from "../views/backoffice/user/details/Appointments.vue";

import BillRoot from "../views/backoffice/accounting/Root.vue";
import BillList from "../views/backoffice/accounting/BillList.vue";
import UnbilledList from "../views/backoffice/accounting/UnbilledList.vue";

import ProductRoot from "../views/backoffice/products/Root.vue";
import ProductList from "../views/backoffice/products/ProductList.vue";
import DigitalMediaList from "../views/backoffice/products/DigitalMediaList.vue";
import DigitalMediaDetail from "../views/backoffice/products/DigitalMediaDetail.vue";
import DigitalBundleList from "../views/backoffice/products/DigitalBundleList.vue";
          
import RetreatList from "../views/backoffice/products/RetreatList.vue";
import RetreatDetail from "../views/backoffice/products/RetreatDetail.vue";
import ProductTypeList from "../views/backoffice/products/ProductTypeList.vue";

import SettingsRoot from "../views/backoffice/settings/Root.vue";
import PremiseList from "../views/backoffice/settings/PremiseList.vue";
import DiagnosisList from "../views/backoffice/settings/DiagnosisList.vue";
import ServiceList from "../views/backoffice/settings/ServiceList.vue";
import RoomList from "../views/backoffice/settings/RoomList.vue";

import CalendarRoot from "../views/backoffice/calendar/Root.vue"
import OwnCalendar from "../views/backoffice/calendar/OwnCalendar.vue"
import RoomCalendar from "../views/backoffice/calendar/RoomCalendar.vue"
import MonthlyCalendar from "../views/backoffice/calendar/MonthlyCalendar.vue"

import { store } from "../store/index.js";

export const backofficeRoutes = [
    {
    path: "/backoffice",
    name: "backoffice",
    component: Root,
    beforeEnter(to, from, next) {
      if (store.state.accessToken) {
        window.scrollTo(0, 0);
        next();
      } else {
        window.scrollTo(0, 0);
        next("/?next=" + window.location.pathname);
      }
    },
    props: {
      displayInNavigation: true,
      rerouteToChild: true,
    },
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: Dashboard,
        props: {
          displayInNavigation: true,
          icon: "view-dashboard",
        },
      },
      {
        path: "products",
        name: "products",
        component: ProductRoot,
        props: {
          displayInNavigation: true,
          icon: "hand-coin",
          rerouteToChild: true
        },
        children: [
          {
            path: "",
            name: "products__main",
            component: ProductList,
            props: {
              displayInNavigation: true,
              icon: "view-dashboard",
              displayName: "productlist",
              routerPermission: ["product_list"],
              postPermission: ["product_post_detail"],
              patchPermission: ["product_patch_detail"],
            },
          },
          {
            path: "digital",
            name: "products__digital",
            component: DigitalMediaList,
            props: {
              displayInNavigation: true,
              icon: "television-classic",
              displayName: "digitalProducts",
              routerPermission: ["digital_media_list"],
              patchPermission: ["digital_media_patch_detail"],
              postPermission: ["digital_media_post_detail"],
            },
          },
          {
            path: "digitalbundles",
            name: "products__bundles",
            component: DigitalBundleList,
            props: {
              displayInNavigation: true,
              icon: "sack-outline",
              displayName: "digitalBundles",
              routerPermission: ["digital_bundle_list", "digital_bundle_detail"],
              patchPermission: ["digital_bundle_patch_detail"],
              postPermission: ["digital_bundle_post_detail"],
            },
          },
          {
            path: "digital/:digitalMediaID",
            name: "products__digital__detail",
            component: DigitalMediaDetail,
            props: {
              displayInNavigation: false,
              icon: "television-classic",
              displayName: "digitalProducts",
              routerPermission: ["digital_media_detail"],
              patchPermission: ["digital_media_patch_detail"],
            },
          },
          {
            path: "producttypes/",
            name: "products__producttypes",
            component: ProductTypeList,
            props: {
              displayInNavigation: true,
              icon: "shape",
              displayName: "productTypes",
              routerPermission: ["product_type_list"],
              patchPermission: ["product_type_patch_detail"],
              postPermission: ["product_type_post_detail"],
            },
          },
          {
            path: "retreat",
            name: "products__retreat",
            component: RetreatList,
            props: {
              displayInNavigation: false,
              icon: "palm-tree",
              displayName: "retreats",
              routerPermission: ["retreat_list"],
              patchPermission: ["retreat_patch_detail"],
              postPermission: ["retreat_post_detail"],
            },
          },
          {
            path: "retreat/:retreatID",
            name: "retreat__detail",
            component: RetreatDetail,
            props: {
              displayInNavigation: false,
              icon: "television-classic",
              displayName: "retreats",
              routerPermission: ["retreat_detail"],
              patchPermission: ["retreat_patch_detail"],
            },
          }
        ]
      },
      {
        path: "calendar",
        name: "calendar",
        component: CalendarRoot,
        props: {
          displayInNavigation: true,
          icon: "calendar-blank",
          rerouteToChild: true
        },
        children: [
          {
            path: "own",
            name: "calendar__own",
            component: OwnCalendar,
            props: {
              displayInNavigation: true,
              icon: "calendar-account",
              displayName: "calendar__own",
              routerPermission: ["own_calendar_detail"],
              patchPermission: ["patch_or_post_timeslot"],
              postPermission: ["patch_or_post_timeslot"],
            },
          },
          {
            path: "room",
            name: "calendar__room",
            component: OwnCalendar,
            props: {
              displayInNavigation: true,
              icon: "calendar-account",
              displayName: "calendar__room",
              routerPermission: ["own_calendar_detail"],
              patchPermission: ["patch_or_post_timeslot"],
              postPermission: ["patch_or_post_timeslot"],
            },
          },
          {
            path: "room",
            name: "calendar__room",
            component: RoomCalendar,
            props: {
              displayInNavigation: true,
              icon: "calendar-search",
              displayName: "calendar__room",
              routerPermission: ["room_calendar_detail"],
              patchPermission: ["patch_or_post_timeslot"],
              postPermission: ["patch_or_post_timeslot"],
            },
          },
          {
            path: "monthly",
            name: "calendar__monthly",
            component: MonthlyCalendar,
            props: {
              displayInNavigation: true,
              icon: "calendar-month",
              displayName: "calendar__monthly",
              routerPermission: ["own_calendar_detail"],
              patchPermission: ["patch_or_post_timeslot"],
              postPermission: ["patch_or_post_timeslot"],
            },
          },
        ]
      },
      {
        path: "accounting",
        name: "accounting",
        component: BillRoot,
        props: {
          displayInNavigation: true,
          icon: "currency-eur",
          rerouteToChild: true
        },
        children: [
          {
            path: "bills",
            name: "accounting_bills",
            component: BillList,
            props: {
              displayInNavigation: true,
              icon: "file-sign",
              routerPermission: ["bill_list"],
              patchPermission: ["bill_patch_detail"],
              postPermission: ["bill_post_detail"],
            },
          }, {
            path: "open",
            name: "accounting_open",
            component: UnbilledList,
            props: {
              displayInNavigation: false,
              icon: "book-open-blank-variant-outline",
              routerPermission: ["bill_list"],
              patchPermission: ["bill_patch_detail"],
              postPermission: ["bill_post_detail"],
            },
          },
        ]
      },
      {
        path: "users/:userID",
        name: "user_detail",
        component: UserDetailRoot,
        props: {
          rerouteToChild: true,
          displayOnActive: true,
          displayName: "users",
          icon: "account-group",
          parentMenu: "users",
          routerPermission: ["user_detail"],
        },
        children: [
          {
            path: "overview",
            name: "user_detail__overview",
            component: UserDetailOverview,
            props: {
              displayInNavigation: true,
              icon: "information-outline",
              routerPermission: ["user_overview_detail"],
            },
          },
          {
            path: "appointments",
            name: "user_detail__appointments",
            component: UserDetailAppointments,
            props: {
              displayInNavigation: true,
              icon: "calendar-blank",
              routerPermission: ["user_appointment_detail"],
            },
          },
          {
            path: "products",
            name: "user_detail__products",
            component: UserDetailProducts,
            props: {
              displayInNavigation: true,
              icon: "television-classic",
              routerPermission: ["user_product_detail"],
            },
          },
        ]

      },
      {
        path: "users",
        name: "users",
        component: UserList,
        props: {
          displayInNavigation: true,
          icon: "account-multiple",
          hideOnActive: "user_detail",
          displayName: "users",
          routerPermission: ["user_list"],
          patchPermission: ["user_patch_detail"],
          postPermission: ["user_post_detail"],
        },
      },
      {
        path: "settings",
        name: "settings",
        component: SettingsRoot,
        props: {
          displayInNavigation: true,
          rerouteToChild: true,
          icon: "cog",
        },
        children: [
          {
            path: "premises",
            name: "settings__premises",
            component: PremiseList,
            props: {
              displayInNavigation: true,
              icon: "domain",
              routerPermission: ['premise_list'],
              postPermission: ['premise_post_detail'],
              patchPermission: ['premise_patch_detail'],
            },

          },
          {
            path: "diagnosis",
            name: "settings__diagnosis",
            component: DiagnosisList,
            props: {
              displayInNavigation: true,
              icon: "doctor",
              routerPermission: ['diagnosis_list'],
              postPermission: ['diagnosis_post_detail'],
              patchPermission: ['diagnosis_patch_detail'],
            },

          },
          {
            path: "services",
            name: "settings__services",
            component: ServiceList,
            props: {
              displayInNavigation: true,
              icon: "toolbox-outline",
              routerPermission: ["service_list"],
              postPermission: ['service_post_detail'],
              patchPermission: ['service_patch_detail'],
            },
          },
          {
            path: "rooms",
            name: "settings__rooms",
            component: RoomList,
            props: {
              displayInNavigation: true,
              icon: "sofa",
              routerPermission: ["room_list"],
              postPermission: ['room_post_detail'],
              patchPermission: ['room_patch_detail'],
            },
          },
        ]
      },
    ],
  },
]